var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2181 13.9373C12.2546 13.9373 13.9056 12.2864 13.9056 10.2498C13.9056 8.21323 12.2546 6.56226 10.2181 6.56226C8.18149 6.56226 6.53052 8.21323 6.53052 10.2498C6.53052 12.2864 8.18149 13.9373 10.2181 13.9373Z",
    stroke: "#9A9AA7",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0216 16.9656L16.5837 13.9253L19.4355 12.7845V7.71567L16.5847 6.57522L17.0227 3.53442L12.6329 1L10.2184 2.89979L7.80387 1L3.41413 3.53442L3.85204 6.57471L1 7.71567V12.7845L3.85304 13.9259L3.41521 16.9656L7.80495 19.5L10.2184 17.6011L12.6319 19.5L17.0216 16.9656Z",
    stroke: "#9A9AA7",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/settingIcon.add89cef930842f98b9646e38f27814b.svg";
export { ForwardRef as ReactComponent };